import React, {useState} from 'react';
import './App.css';
import {Home} from './componentes/home';
import {Expediente} from './componentes/expedientes';
import {Gasto} from './componentes/gastos';
import {Tramite} from './componentes/tramites';

import Login from './componentes/login';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {Navigation} from './componentes/navigation';
import {IntlProvider,} from 'react-intl';

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import {Api} from "./Api";


//const API_PATH = "http://localhost:8080";
const API_PATH =  'http://st.panalcobranzas.com.py:8083'
//const API_PATH =  'http://localhost:8080'
let api = new Api('', API_PATH)

export function getApi() {
  return api;
}

function App() {
  const [userData, setUserData] = useState();

  function loginExitoso(newUser) {
    api = new Api(newUser.token, API_PATH);
    setUserData(newUser);
  }

  function logout() {
    api = new Api('', API_PATH);
    setUserData(undefined);
  }

  // si no se realizo el login enviar directo.
  if (!userData) return <BrowserRouter><Login onSuccess={(datos) =>  loginExitoso(datos)}/> </BrowserRouter>

  return (
      <IntlProvider locale="es">
        <BrowserRouter>
          <div className="container">
            <AppBar position="static">
              <Toolbar>
                <Typography variant="h6" className="barra">
                  Gestión de Gastos Jurídicos
                </Typography>

              </Toolbar>
            </AppBar>

            <Navigation logout={logout}/>
            <h5 className="m-3 d-flex justify-content-center">
              Bienvenido {userData.razonSocial} !
            </h5>
            <Switch>
              <Route path='/' component={Home} exact/>
              <Route path='/expedientes/:id/gastos' component={Gasto} exact/>
              <Route path='/expedientes/:id/tramites' component={Tramite} exact/>
              {/* explicacion
                El Route espera que en 'component' le pases un comopnente react

                Un componente react puede ser:

                  * un class que extiende de react.Component
                  * una funcion que reciba un argumento y retorna un <ALGO>
                  
                Cunado le pasabamos solo <Expediente cob.... />
                Eso no es un componente, por que digamos que ya esta 'renderizado', no es
                algo a renderizar.

                Pro eso ahora le pasamos una funcion:

                props => <Expediente cod...>


                Es una funcion qeu recibe un solo argumento y retorna un <ALGO>

                <Expediente codAbogado={userData.codAbogado} />  va a funcionar, pero ademas de eso,
                se necesita algunas otras props que vienen 'magicamente' al usar el router, como 'props.history'.

                Para pasar estas propiedades usamos {...props}, que es una manera corta de decir:

                1. Por cada atributo de 'props'
                2. Ponele atributo={props.atributo}

                por eso funca

                Q7ue te den
                Monstruo...
                */}
              <Route path='/expedientes/' component={props => <Expediente codAbogado={userData.codAbogado} {...props}/>}
                    exact/>

            </Switch>

          </div>
        </BrowserRouter>
      </IntlProvider>

  );
}

export default App;
